<template>
  <card-component title="Portal de Activación" icon="lock" :has-card-header-background="true" :has-button-slot="true">
    <form @submit.prevent="submit" method="POST">
      <b-field label="CC/DNI" >
        <b-input v-model="dni" name="dni" validation-message="Solo numeros"
              pattern="[0-9]*" required autofocus/>
      </b-field>
      <hr>
      <div class="control">
        <b-button native-type="submit" class="button is-primary" expanded :class="{'is-loading':isLoadingStartClaim}">
          Activar Cuenta
        </b-button>
      </div>
    </form>
  </card-component>
</template>

<script>
import CardComponent from '@/components/CardComponent'
import TokenRepository from '@/services/TokenRepository'
import ValidDNIRepository from '@/services/ValidDNIRepository'

export default {
  name: 'StartClaim',
  components: { CardComponent },
  data () {
    return {
      isLoadingStartClaim: false,
      isLoadingChangePassword: false,
      dni: null
    }
  },
  mounted () {
    this.$buefy.dialog.alert('¡Hola! Estás a 3 pasos de activar tu cuenta en Vive Auna Workplace:<br> 1. Coloca tu número de Cédula/DNI y dale «Activar cuenta/Cambiar contraseña».<br> 2. Responde la pregunta y dale a «Enviar respuesta» y serás dirigido a Vive Auna Workplace.<br> 3. Este portal es para los colaboradores Auna que no cuentan con correo corporativo. Si tienes correo, puedes entrar directamente a la aplicación de Workplace.')
  },
  methods: {
    submit () {
      this.isLoadingStartClaim = true
      setTimeout(() => {
        this.isLoading = false
        this.$store.dispatch('startClaim', this.dni
        ).then(result => {
          this.$router.push('/answer-questions')
        }).catch((error) => {
          this.isLoadingStartClaim = false
          this.showErrorToast(error)
        })
      }, 750)
    },
    changePassword () {
      if (this.dni) {
        this.isLoadingChangePassword = true
        ValidDNIRepository.changePassword(this.dni)
          .then((r) => {
            this.requestToken(r.data.user_id, r.data)
          }).catch(e => {
            this.isLoadingChangePassword = false
            this.showErrorToast(e)
          })
      }
    },
    showErrorToast (error) {
      let type = 'is-danger'
      let message = 'CC/DNI invalido'
      if (error.response.status === 400) {
        type = 'is-info'
        message = error.response.data.detail
      }
      this.$buefy.toast.open({
        message: message,
        type: type
      })
    },
    requestToken (id, data) {
      TokenRepository.requestTokenSMS(id, data)
        .then((r) => {
          this.isLoadingChangePassword = false
          this.promptToken(id, data.phone_number)
        }).catch(e => {
          this.isLoadingChangePassword = false
          this.$buefy.toast.open({
            message: `Error: ${e.response.data.detail}`,
            type: 'is-danger'
          })
        })
    },
    getTokenSMS (token) {
      return {
        token_sms: token
      }
    },
    promptToken (idUser, phoneNumber) {
      this.$buefy.dialog.prompt({
        message: 'Escribe el código enviado al número ' + phoneNumber,
        inputAttrs: {
          type: 'text'
        },
        confirmText: 'Enviar Código',
        cancelText: 'Cancelar',
        trapFocus: true,
        closeOnConfirm: false,
        canCancel: ['escape', 'button'],
        onConfirm: (value, { close }) => {
          this.isLoading = true
          this.$buefy.toast.open('Validando código ...')
          TokenRepository.claimWorkplaceURL(idUser, this.getTokenSMS(value))
            .then((r) => {
              this.$store.commit('removeIDUser')
              window.location.replace(r.data.url_to_claim)
            }).catch(e => {
              this.isLoading = false
              this.$buefy.toast.open({
                message: `Error: ${e.response.data.detail}`,
                type: 'is-danger'
              })
            })
        },
        onCancel: () => {
          this.phoneNumber = null
        }
      })
    }
  }
}
</script>
